<div class="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
  <div>
    <div class="d-flex flex-column">
      <span class="fw-bold"><i class="pi pi-list me-2"></i>Actividades <p-badge severity="secondary"
          [value]="maintenanceRoutineDetails.length" /></span>
      <small class="text-muted">{{elementModel.name}}</small>
    </div>
  </div>
  <app-custom-button [title]="'Agregar'" [label]="'Agregar'" [icon]="'pi pi-plus'" [disabled]="disabledForm"
    [width]="'5.5rem'" [variant]="undefined" (onClick)="addActivities()"></app-custom-button>

  <app-custom-modal #activitiesModal [label]="'Selección de actividades'" [width]="'70rem'"
    [header]="'Selección de actividades'" [children]="registerDetailModal" [inputs$]="inputsForRegister$"
    [output$]="output$" hidden>
  </app-custom-modal>

</div>
<div id="table-routine" *ngIf="maintenanceRoutineDetails.length > 0">
  <p-table [value]="maintenanceRoutineDetails" [rows]="10" [scrollable]="true" [showGridlines]="true"
    styleClass="p-datatable-sm ">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 80px">Código</th>
        <th>Descripción</th>
        <th class="text-center">C/Uso</th>
        @for (pm of ['PM1', 'PM2', 'PM3', 'PM4', 'PM5', 'PM6', 'PM7']; track pm) {
        <th class="text-center">{{pm}}</th>
        }
        <th class="text-center" alignFrozen="right">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-act>
      <tr>
        <td class="fw-bold text-primary text-center">{{ act.maintenanceActivitiesCode }}</td>
        <td>{{ act.maintenanceActivitiesDescription }}</td>
        <td class="text-center">
          <p-checkbox inputId="swEachUse{{act.maintenanceRoutineDetailId}}" binary="true" [ngModel]="act.swEachUse"
            [disabled]="active" autocomplete="off" (onChange)="changeCheckBox(act,swEachUse)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan1{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan1" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan1)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan2{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan2" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan2)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan3{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan3" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan3)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan4{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan4" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan4)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan5{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan5" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan5)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan6{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan6" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan6)" />
        </td>
        <td class="text-center"> <p-checkbox inputId="swMaintenancePlan7{{act.maintenanceRoutineDetailId}}"
            binary="true" [ngModel]="act.swMaintenancePlan7" autocomplete="off" [disabled]="active"
            (onChange)="changeCheckBox(act,swMaintenancePlan7)" />
        </td>
        <td class="text-center"> <button pButton type="button" icon="pi pi-trash" title="Eliminar"
            class="p-button-text p-button-sm p-button-rounded" [disabled]="active" (click)="delete(act)"></button></td>
      </tr>
    </ng-template>
  </p-table>
</div>